export const AuthMicrosoftActionEnum = {
  Login: "MS_LOGIN",
  Logout: "MS_LOGOUT",
  Error: "MS_ERROR"
};

export function getAuthMicrosoftErrorMessage(code) {
  switch (code) {
    case 403:
      return "คุณไม่มีสิทธิ์เข้าถึงระบบนี้ กรุณาติดต่อผู้ดูแลระบบ";
    case 500:
      return "เกิดข้อผิดพลาดภายในระบบ กรุณาลองใหม่อีกครั้งในภายหลัง";
    case 502:
      return "เกิดข้อผิดพลาดในการเชื่อมต่อกับ Microsoft กรุณาลองใหม่อีกครั้ง";
    default:
      return "เกิดข้อผิดพลาดที่ไม่ทราบสาเหตุ กรุณาลองใหม่อีกครั้งในภายหลัง";
  }
}



// WEBPACK FOOTER //
// ./src/features/auth/auth-microsoft.js